import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import RoofingHero from './components/RoofingHero';
import RoofingServices from './components/RoofingServices';
import RoofTypesElPaso from './components/RoofTypesElPaso';
import ContractorDirectory from './components/ContractorDirectory';
import ComparisonChecklist from './components/ComparisonChecklist';
import RoofingFAQ from './components/RoofingFAQ';

export default function RoofingPage() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Header />
      <main>
        <RoofingHero />
        <RoofingServices />
        <RoofTypesElPaso />
        <ContractorDirectory />
        <ComparisonChecklist />
        <RoofingFAQ />
      </main>
      <Footer />
    </div>
  );
}
